import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ratnaImage from '../../../../images/discovery/ratna.svg';
import ratnaIllustration from '../../../../images/ratna/ratna-illustration.png';
import { getPlans } from '../../../../services/payment.service';
import SupportQuestion from '../../../Icons/icons/SupportQuestion';
import ButtonComponent from '../../ButtonComponent/ButtonComponent';
import ModalComponent from '../ModalComponent';
import OneTimeRatnaBoostSection from './OneTimeRatnaBoostSection';
import RatnaDescription from './RatnaDescription';

import '../_modalComponent.scss';

import { setShowBuyRatnaModalLeftSection } from '@/redux/user/userActions';
import { Mixpanel } from '@/utils/mixpanel';
import { GLEAP_TAILOR_PLAN_FORM_KEY } from '@/utils/ts/gleap';
import Gleap from 'gleap';

interface BuyRatnaModalProps {
  show: boolean;
  handleClose: () => void;
}

interface Plan {
  _id: string;
  title: string;
  ratnas: number;
  price: number;
  planId: string;
}

const BuyRatnaModal: React.FC<BuyRatnaModalProps> = ({ show, handleClose }) => {
  const [plans, setPlans] = useState(undefined);
  const [selectedPlan, setSelectedPlan] = useState('Favorite');
  const { showBuyRatnaModal, userDetails, showBuyRatnaLeftSection } = useSelector((state: any) => state.user);
  const [leftSection, setLeftSection] = useState(showBuyRatnaLeftSection);

  const isV2User = userDetails?.accountVersion === 'v2' ? true : false;

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPlans = async () => {
      const response = await getPlans();
      if (response.success === true) {
        setPlans(response.data);
        const foundPlan = response?.data?.find((p: Plan) => p.title === 'Favorite');
        const newSelectedPlanId = foundPlan?.planId || response.data[0].planId;
        setSelectedPlan(newSelectedPlanId);
      }
    };
    fetchPlans();
  }, []);

  useEffect(() => {
    setLeftSection(showBuyRatnaLeftSection);
  }, [showBuyRatnaLeftSection]);

  return (
    <ModalComponent
      show={show}
      onClose={() => {
        handleClose();
        dispatch(setShowBuyRatnaModalLeftSection('ratna-description'));
      }}
      width={1000}
      outsideClickClose={true}
      style={{ padding: 0 }}
      bodyStyle={{ padding: 0 }}>
      <div className={`modal-main-content buy-ratna-modal ${showBuyRatnaModal === 'dark' && 'buy-ratna-modal-dark'}`}>
        <div className="left-modal-div">
          {leftSection === 'ratna-description' ? (
            <RatnaDescription setLeftSection={setLeftSection} />
          ) : (
            <OneTimeRatnaBoostSection
              plans={plans}
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              setLeftSection={setLeftSection}
            />
          )}
        </div>
        <div className="right-modal-div">
          <h2 className="buy-ratna-modal-description-heading">
            <img width="28px" height="28px" src={ratnaImage} alt="celebration" /> Get a Tailor-made Plan
          </h2>
          <p className="buy-ratna-modal-description-subheading center">
            Do you want to find to more than {userDetails?.plan?.ratnaCount} influencers <br/> per month on a regular basis?
            <br />
            <br /> We’ll set you up with a custom package that <br /> enables your desired volume.{' '}
            {!isV2User && 'Pay only for what you need.'}
          </p>
          <div className="image-container buy-ratna-modal-illustration-container">
            <img width="436px" height="291px" src={ratnaIllustration} alt="" style={{ width: '436px', height: '291px' }} />
          </div>
          <ButtonComponent
            style={{ marginTop: '24px', width: '100%' }}
            onClick={() => {
              Gleap.setTicketAttribute('Intent', 'I want to get on a tailor-made plan with more influencers per month');
              Gleap.startClassicForm(GLEAP_TAILOR_PLAN_FORM_KEY, true);

              Mixpanel.identify(userDetails?._id);
            }}>
            Talk to the team
          </ButtonComponent>
          {!isV2User && (
            <a
              className="help-text"
              href="https://getsaral.notion.site/What-is-Ratna-and-why-am-I-charged-extra-to-save-influencers-9da8359e94da4750bf36fdd9fce4b020"
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                Mixpanel.identify(userDetails?._id);
              }}>
              <SupportQuestion />
              What is Ratna? Why do I need to pay more?
            </a>
          )}
        </div>
      </div>
    </ModalComponent>
  );
};

export default BuyRatnaModal;
